import { WORKLOAD_INSERT, WORKLOAD_REMOVE, WORKLOAD_RESET } from '@root/constants/actionTypes';

const initialState = {
  workloads: [],
};

const workloadOnboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORKLOAD_INSERT:
      return {
        ...state,
        workloads: [
          ...state.workloads,
          ...action.payload.filter(
            newItem => !state.workloads.some(existingItem => existingItem.resource_name === newItem.resource_name),
          ),
        ],
      };
    case WORKLOAD_REMOVE:
      return {
        ...state,
        workloads: state.workloads.filter(
          event => !action.payload.some(payloadEvent => payloadEvent.resource_name === event.resource_name),
        ),
      };
    case WORKLOAD_RESET:
      return {
        ...state,
        workloads: [],
      };
    default:
      return state;
  }
};

export default workloadOnboardingReducer;
